import React from 'react'
import { useIntl } from 'react-intl'

import { HouseStudyDayIndividualFieldProps } from '../form-container/HouseStudyDayIndividualFormContainer'
import { ControlledSwitchField } from '../../../../../../../../forms'

export const HouseStudyDayIndividualIsEnabledField = ({
  control,
  isFieldDisabled,
}: Omit<HouseStudyDayIndividualFieldProps, 'currencyArea'>) => {
  const intl = useIntl()
  return (
    <ControlledSwitchField
      control={control}
      name='isEnabled'
      label={intl.formatMessage({
        defaultMessage: 'Acceptez-vous les séjours à la journée ?',
        id: 'ui.HouseStudyDayIndividualIsEnabledField.label',
      })}
      inline={true}
      disabled={isFieldDisabled}
    />
  )
}
